<template>
	<div class="contain">
		<!-- <el-scrollbar style="height:100%;"> -->
			<el-row>
				<el-col :span="24" class="bold-head">添加老人定位数据</el-col>
			</el-row>
			<el-row>
				<el-col :span="24"><span class="bold">(1)接口说明 :</span>在添加老人的基础上添加老人定位数据</el-col>
			</el-row>
			<el-row>
				<el-col :span="24"><span class="bold"> (2)请求方式 :</span> post</el-col>
			</el-row>
			<el-row>
				<el-col :span="24"><span class="bold">(3)Url :</span> http://121.46.26.109:8060/api/saveElderlyLocation </el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">header</el-col>
			</el-row>
			<el-table :data="tableOne" border style="width: 100%" class="table-contain">
				<el-table-column prop="name" label="参数名">
				</el-table-column>
				<el-table-column prop="shuoming" label="说明">
				</el-table-column>
				<el-table-column prop="type" label="类型">
				</el-table-column>
				<el-table-column prop="fanwei" label="取值范围">
				</el-table-column>
				<el-table-column prop="pos" label="参数位置">
				</el-table-column>
				<el-table-column prop="select" label="是否必选">
				</el-table-column>
			</el-table>
			<el-row>
				<el-col :span="24" class="bold">body</el-col>
			</el-row>
			<el-table :data="tableTwo" border style="width: 100%" class="table-contain">
				<el-table-column prop="name" label="参数名">
				</el-table-column>
				<el-table-column prop="shuoming" label="说明">
				</el-table-column>
				<el-table-column prop="type" label="类型">
				</el-table-column>
				<el-table-column prop="fanwei" label="取值范围">
				</el-table-column>
				<el-table-column prop="pos" label="参数位置">
				</el-table-column>
				<el-table-column prop="select" label="是否必选">
				</el-table-column>
			</el-table>
			<el-row>
				<el-col :span="24" class="bold">返回参数</el-col>
			</el-row>
			<el-table :data="tableThree" border style="width: 100%" class="table-contain">
				<el-table-column prop="name" label="参数名">
				</el-table-column>
				<el-table-column prop="shuoming" label="说明">
				</el-table-column>
				<el-table-column prop="type" label="类型">
				</el-table-column>
			</el-table>
			<el-row>
				<el-col :span="24" class="bold">（4）示例</el-col>
			</el-row>
			<el-row class="contain-bg">
				<el-col :span="24">{</el-col>
				<el-col :span="24">"idcardno":"320683199809143663",</el-col>
				<el-col :span="24">"source":"2",</el-col>
				<el-col :span="24">"sourceNumber":"1111",</el-col>
				<el-col :span="24">"lat":23.3,</el-col>
				<el-col :span="24">"lng":54.3,</el-col>
				<el-col :span="24">"fenceStatus":"测试",</el-col>
				<el-col :span="24">"areaName":"南京"</el-col>
				<el-col :span="24">}</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">成功返回</el-col>
			</el-row>
			<div>
				<el-row class="contain-bg">
					<el-col :span="24">{</el-col>
					<el-col :span="24">"success": 1,</el-col>
					<el-col :span="24">"message": "添加成功"</el-col>
					<el-col :span="24">}</el-col>
				</el-row>
			</div>

		<!-- </el-scrollbar> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableOne: [{
					name: 'token',
					shuoming: 'getToken 获取的token',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}],
				tableTwo: [{
					name: 'areaName',
					shuoming: '区域名称',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'

				}, {
					name: 'idcardno',
					shuoming: '老人身份证号码',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'source',
					shuoming: '来源',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'sourceNumber',
					shuoming: '来源编码',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'lat',
					shuoming: '纬度',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'lng',
					shuoming: '经度',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}, {
					name: 'fenceStatus',
					shuoming: '围栏状态',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: ''
				}],
				tableThree: [{
					name: 'success',
					shuoming: '是否成功 (1:成功2:失败)',
					type: 'int'

				}, {
					name: 'data',
					shuoming: '数据',
					type: 'String'
				}, {
					name: 'message',
					shuoming: '返回信息',
					type: 'String'
				}]
			}
		}
	}
</script>

<style scoped="scoped">
	/* .contain {
		width: 98%;
		margin: 0 auto;
		font-size: 16px;
		overflow-y: scroll;
		height: 800px;
		padding: 10px 0 0 20px;
	}
	::-webkit-scrollbar {
		width: 6px;
		
	}
	::-webkit-scrollbar-thumb {
		border-radius: 3px;
		height: 100px;
		background-color: #ccc;
	} */
	.contain{
		/* width: 100%; */
		background: #fff;
		padding:20px 30px;
		font-size: 16px;
	}
	.contain .el-row {
		margin-bottom: 10px;
	}
	
	
	.contain-bg {
		/* width:100%; */
		padding: 20px 0 20px 20px;
		background: #f9f9fa;
	}
	.contain-bg .el-col{
		font-size:14px;
	}
	
	.bold {
		font-size: 18px;
		font-weight: bold;
	}
	
	.table-contain {
		margin: 20px 0;
	}
	
	.bold-head {
		font-size: 20px;
		font-weight: bold;
		margin-bottom:20px;
	}
</style>
